import { LayoutPage } from './page';

export const Layout = {
  Page: LayoutPage
};
